import React, { useEffect, useRef, useState } from 'react';
import '../styles/MembersAdmin.css';
import { FaPlusCircle, FaSearch, FaGlobe, FaPhone, FaEnvelope, FaFacebook, FaLinkedin, FaInstagram, FaTrash } from 'react-icons/fa';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import axios from 'axios';
import config from '../../../constants/config';
import { IoMdRefresh } from 'react-icons/io';
import axiosPost from '../../../helper/axios-helper';
import { useCookies } from 'react-cookie';
import { useOutletContext } from 'react-router-dom';

export default function MembersAdmin() {
    const { account } = useOutletContext() || {};
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const { openSlideout } = useSlideout();
    const [countries, setCountries] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [cookies] = useCookies(["account-canto"]);

    // Mock data for members and countries
    const mockMembers = [
        {
            id: 1,
            name: "Digicel Anguilla",
            member_type: "Full Member",
            logo_url: "https://logowik.com/content/uploads/images/digicel5375.jpg",
            country: "Anguilla",
            website: "https://www.digicelgroup.com/ai/en/mobile.html",
            email: "info@digicelanguilla.com",
            phone: "+1 264-123-4567",
            socials: {
                facebook: "https://facebook.com/digicelanguilla",
                twitter: "https://twitter.com/digicelanguilla",
                linkedin: "https://linkedin.com/company/digicel-anguilla",
                instagram: "https://instagram.com/digicelanguilla"
            },
            active: 1
        },
        {
            id: 2,
            name: "Digicel - Aruba",
            member_type: "Full Member",
            logo_url: "https://logowik.com/content/uploads/images/digicel5375.jpg",
            country: "Aruba",
            website: "https://www.digicelgroup.com/aw/en/mobile.html",
            email: "info@digicelAruba.com",
            phone: "+297 123-4567",
            socials: {
                facebook: "https://facebook.com/digicelAruba",
                twitter: "https://twitter.com/digicelAruba",
                linkedin: "https://linkedin.com/company/digicel-Aruba",
                instagram: "https://instagram.com/digicelAruba"
            },
            active: 1
        },
        {
            id: 3,
            name: "Antigua Public Utilities Authority",
            member_type: "Full Member",
            logo_url: "https://apua.ag/wp-content/uploads/2020/05/APUA_LOGO.png",
            country: "Antigua",
            website: "https://apua.ag",
            email: "info@apua.ag",
            phone: "+1 268-480-7000",
            socials: {
                facebook: "https://facebook.com/apua",
                twitter: "https://twitter.com/apua",
                linkedin: "https://linkedin.com/company/apua",
                instagram: "https://instagram.com/apua"
            },
            active: 1
        }
    ];

    const mockCountries = [
        {
            id: 1,
            country: "Anguilla",
            image: "https://flagcdn.com/w320/ai.png",
            location: { lat: 18.2206, lng: -63.0686 }
        },
        {
            id: 2,
            country: "Aruba",
            image: "https://flagcdn.com/w320/aw.png",
            location: { lat: 12.5211, lng: -69.9683 }
        },
        {
            id: 3,
            country: "Antigua",
            image: "https://flagcdn.com/w320/ag.png",
            location: { lat: 17.0608, lng: -61.7964 }
        },
        {
            id: 4,
            country: "Bahamas",
            image: "https://flagcdn.com/w320/bs.png",
            location: { lat: 25.0343, lng: -77.3963 }
        },
        {
            id: 5,
            country: "Barbados",
            image: "https://flagcdn.com/w320/bb.png",
            location: { lat: 13.1939, lng: -59.5432 }
        }
    ];

    useEffect(() => {
        // Fetch real data from the API
        fetchMembers();
        fetchCountries();
        
        // Fallback to mock data if API calls fail
        // This can be removed once API is fully implemented
        // setMembers(mockMembers);
        // setCountries(mockCountries);
    }, []);

    const fetchMembers = () => {
        setLoading(true);
        axiosPost('admin/members/fetch', {}, {}, (data) => {
            const { success, response } = data;
            if (success) {
                setMembers(data.data);
                console.log('Members fetched:', data.data);
            } else {
                console.log('Error fetching members:', response);
            }
            setLoading(false);
        });
    };

    const fetchCountries = () => {
        axiosPost('admin/members/countries/fetch', {}, {}, (data) => {
            const { success, response } = data;
            if (success) {
                setCountries(data.data);
                console.log('Countries fetched:', data.data);
            } else {
                console.log('Error fetching countries:', response);
                // Fallback to mock data if API call fails
                setCountries(mockCountries);
            }
        });
    };

    const filteredMembers = members.filter(member => 
        member.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        member.country.toLowerCase().includes(searchQuery.toLowerCase()) ||
        member.member_type.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const EditMember = ({ member, fetchMembers }) => {
        const { closeSlideout } = useSlideout();
        const [memberData, setMemberData] = useState({
            id: member?.id || "",
            name: member?.name || "",
            member_type: member?.member_type || "Full Member",
            country: member?.country || "",
            country_id: member?.country_id || 0,
            website: member?.website || "",
            email: member?.email || "",
            phone: member?.phone || "",
            facebook_link: member?.facebook_link || "",
            linkedin_link: member?.linkedin_link || "",
            instagram_link: member?.instagram_link || "",
            active: member?.active === "1"
        });

        const [loading, setLoading] = useState(false);
        const [selectedLogoFile, setSelectedLogoFile] = useState(null);
        const [selectedLogoPreview, setSelectedLogoPreview] = useState(member?.image || "");
        const fileInputRef = useRef(null);

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setMemberData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle file selection
        const handleLogoChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file);
                setSelectedLogoFile(file);
                setSelectedLogoPreview(imageUrl);
            }
        };

        // Open file input
        const handleSelectLogo = () => {
            fileInputRef.current.click();
        };

        // Handle save changes
        const handleSaveChanges = () => {
            setLoading(true);

            const formData = new FormData();
            const isNew = !memberData.id || Number(memberData.id) === 0;

            // Include id only for edit
            if (!isNew) {
                formData.append("id", memberData.id);
            }
            formData.append("name", memberData.name);
            formData.append("member_type", memberData.member_type);
            formData.append("country_id", memberData.country_id || 0);
            // Optional fields (website is ignored by add endpoint but kept for edit compatibility)
            formData.append("website", memberData.website || "");
            formData.append("email", memberData.email);
            formData.append("phone", memberData.phone);
            // Align to backend keys
            formData.append("facebook", memberData.facebook_link || "");
            formData.append("linkedin", memberData.linkedin_link || "");
            formData.append("instagram", memberData.instagram_link || "");
            formData.append("active", 1);

            // Add location coordinates if available
            if (memberData.lat) formData.append("lat", memberData.lat);
            if (memberData.lng) formData.append("lng", memberData.lng);

            if (selectedLogoFile) {
                formData.append("logo", selectedLogoFile);
            }

            const endpoint = isNew ? "admin/members/add" : "admin/members/edit";

            axios.post(config.api.url + endpoint, formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj" // TODO: replace with actual auth token from context/session
                    // Do not set Content-Type; browser will set boundary for FormData
                }
            })
            .then((response) => {
                const { success, response: message, data } = response.data;
                if (success) {
                    console.log("Member saved successfully:", data);
                    fetchMembers();
                    closeSlideout();
                } else {
                    console.error("Error saving member:", message);
                    alert("Error saving member: " + message);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("API error:", error);
                alert("Error connecting to the server. Please try again.");
                setLoading(false);
            });
        };

        return (
            <div className="MemberEditContainer">
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleLogoChange}
                    accept="image/*"
                    style={{ display: 'none' }}
                />
                
                <div className="MemberEditSection">
                    <div className="MemberEditSectionTitle">Member Information</div>
                    
                    <div className="MemberEditLogoSection">
                        <div 
                            className="MemberEditLogo" 
                            style={{ backgroundImage: `url(${selectedLogoPreview || "https://via.placeholder.com/150"})` }}
                            onClick={handleSelectLogo}
                        />
                        <button className="MemberEditLogoButton" onClick={handleSelectLogo}>
                            Change Logo
                        </button>
                    </div>

                    <div className="MemberEditFormGroup">
                        <label>Member Name*</label>
                        <input
                            type="text"
                            name="name"
                            value={memberData.name}
                            onChange={handleChange}
                            placeholder="Enter member name"
                            required
                        />
                    </div>

                    <div className="MemberEditFormGroup">
                        <label>Member Type*</label>
                        <select
                            name="member_type"
                            value={memberData.member_type}
                            onChange={handleChange}
                            required
                        >
                            <option value="Full Member">Full Member</option>
                            <option value="Affiliate Member">Affiliate Member</option>
                        </select>
                    </div>

                    <div className="MemberEditFormGroup">
                        <label>Country*</label>
                        <select
                            name="country_id"
                            value={memberData.country_id}
                            onChange={(e) => {
                                const countryId = parseInt(e.target.value);
                                const selectedCountry = countries.find(c => c.id === countryId);
                                setMemberData(prev => ({
                                    ...prev,
                                    country_id: countryId,
                                    country: selectedCountry ? selectedCountry.country : ''
                                }));
                            }}
                            required
                        >
                            <option value="">Select a country</option>
                            {countries.map(country => (
                                <option key={country.id} value={country.id}>
                                    {country.country}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="MemberEditSection">
                    <div className="MemberEditSectionTitle">Contact Information</div>
                    
                    <div className="MemberEditFormGroup">
                        <label>Website</label>
                        <input
                            type="url"
                            name="website"
                            value={memberData.website}
                            onChange={handleChange}
                            placeholder="https://example.com"
                        />
                    </div>

                    <div className="MemberEditFormGroup">
                        <label>Email</label>
                        <input
                            type="email"
                            name="email"
                            value={memberData.email}
                            onChange={handleChange}
                            placeholder="contact@example.com"
                        />
                    </div>

                    <div className="MemberEditFormGroup">
                        <label>Phone</label>
                        <input
                            type="text"
                            name="phone"
                            value={memberData.phone}
                            onChange={handleChange}
                            placeholder="+1 234-567-8900"
                        />
                    </div>
                </div>

                <div className="MemberEditSection">
                    <div className="MemberEditSectionTitle">Social Media</div>
                    
                    <div className="MemberEditFormGroup">
                        <label>Facebook</label>
                        <input
                            type="url"
                            name="facebook_link"
                            value={memberData.facebook_link}
                            onChange={handleChange}
                            placeholder="https://facebook.com/page"
                        />
                    </div>

                    

                    <div className="MemberEditFormGroup">
                        <label>LinkedIn</label>
                        <input
                            type="url"
                            name="linkedin_link"
                            value={memberData.linkedin_link}
                            onChange={handleChange}
                            placeholder="https://linkedin.com/company/name"
                        />
                    </div>

                    <div className="MemberEditFormGroup">
                        <label>Instagram</label>
                        <input
                            type="url"
                            name="instagram_link"
                            value={memberData.instagram_link}
                            onChange={handleChange}
                            placeholder="https://instagram.com/handle"
                        />
                    </div>
                </div>

                {/* <div className="MemberEditSection">
                    <div className="MemberEditFormGroup Checkbox">
                        <label>
                            <input
                                type="checkbox"
                                name="active"
                                checked={memberData.active}
                                onChange={handleChange}
                            />
                            Active
                        </label>
                    </div>
                </div> */}

                <div className="MemberEditActions">
                    <button 
                        className="MemberEditCancelButton"
                        onClick={closeSlideout}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button 
                        className="MemberEditSaveButton"
                        onClick={handleSaveChanges}
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "Save Changes"}
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="MembersAdminContainer">
            <div className="MembersAdminHeader">
                <div className="MembersAdminHeaderTitle">
                    <h1>Members Management</h1>
                    <p>Manage members displayed on the membership map</p>
                </div>
                <div className="MembersAdminHeaderActions">
                    <div className="MembersAdminSearch">
                        <FaSearch />
                        <input 
                            type="text" 
                            placeholder="Search members..." 
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <button 
                        className="MembersAdminAddButton"
                        onClick={() => {
                            openSlideout({
                                title: 'Add New Member',
                                content: <EditMember fetchMembers={fetchMembers} />
                            });
                        }}
                    >
                        <FaPlusCircle />
                        <span>Add Member</span>
                    </button>
                    <button 
                        className="MembersAdminRefreshButton"
                        onClick={fetchMembers}
                        disabled={loading}
                    >
                        <IoMdRefresh className={loading ? "spinning" : ""} />
                    </button>
                </div>
            </div>

            <div className="MembersAdminContent">
                <div className="MembersAdminTable">
                    <div className="MembersAdminTableHeader">
                        <div className="MembersAdminTableHeaderCell Status">Status</div>
                        <div className="MembersAdminTableHeaderCell Logo">Logo</div>
                        <div className="MembersAdminTableHeaderCell Name">Name</div>
                        <div className="MembersAdminTableHeaderCell Type">Type</div>
                        <div className="MembersAdminTableHeaderCell Country">Country</div>
                        <div className="MembersAdminTableHeaderCell Actions">Actions</div>
                    </div>
                    
                    <div className="MembersAdminTableBody">
                        {filteredMembers.length > 0 ? (
                            filteredMembers.map(member => (
                                <div key={member.id} className="MembersAdminTableRow">
                                    <div className="MembersAdminTableCell Status">
                                        <span className={`StatusIndicator ${member.active === "1" ? 'Active' : 'Inactive'}`}>
                                            {member.active === "1"
                                                ? <RiCheckFill />
                                                : <RiCloseFill />
                                            }
                                        </span>
                                    </div>
                                    <div className="MembersAdminTableCell Logo">
                                        <div 
                                            className="MemberLogo" 
                                            style={{ backgroundImage: `url(${member.image || "https://via.placeholder.com/150"})` }}
                                        />
                                    </div>
                                    <div className="MembersAdminTableCell Name">{member.name}</div>
                                    <div className="MembersAdminTableCell Type">{member.member_type}</div>
                                    <div className="MembersAdminTableCell Country">{member.country}</div>
                                    <div className="MembersAdminTableCell Actions">
                                        <button 
                                            className={`ActionButton Toggle ${member.active === 1 ? 'Active' : 'Inactive'}`}
                                            onClick={() => {
                                                // Toggle active status
                                                setMembers(prevMembers => 
                                                    prevMembers.map(m => 
                                                        m.id === member.id 
                                                            ? {...m, active: m.active === 1 ? 0 : 1}
                                                            : m
                                                    )
                                                );
                                            }}
                                        >
                                            {member.active === "1"
                                                ? <RiToggleFill />
                                                : <RiToggleLine />
                                            }
                                            <span>{member.active === "1" ? 'Deactivate' : 'Activate'}</span>
                                        </button>
                                        <button 
                                            className="ActionButton Delete"
                                            type="button"
                                            onClick={() => {
                                                if (!window.confirm(`Are you sure you want to delete "${member.name}"? This action cannot be undone.`)) {
                                                    return;
                                                }
                                                setLoading(true);
                                                axiosPost('admin/members/delete', { auth: account?.auth_token || cookies['account-canto'] }, { id: member.id }, (data) => {
                                                    const { success, response } = data;
                                                    if (success) {
                                                        fetchMembers();
                                                    } else {
                                                        alert('Error deleting member: ' + (response || 'Unknown error'));
                                                    }
                                                    setLoading(false);
                                                });
                                            }}
                                            disabled={loading}
                                        >
                                            <FaTrash />
                                            <span>Delete</span>
                                        </button>

                                        <button 
                                            className="ActionButton Edit"
                                            onClick={() => {
                                                openSlideout({
                                                    title: 'Edit Member',
                                                    content: <EditMember member={member} fetchMembers={fetchMembers} />
                                                });
                                            }}
                                        >
                                            <RiFileShield2Line />
                                            <span>Edit</span>
                                        </button>
                                        
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="MembersAdminTableEmpty">
                                {searchQuery ? 'No members found matching your search.' : 'No members found. Add your first member!'}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
